import { Alert } from '@mui/material';

interface AppraisalValidationBannerProps {
  errors: string[];
}

export function AppraisalValidationBanner({ errors }: AppraisalValidationBannerProps) {
  if (errors.length === 0) return null;

  return (
    <Alert severity="error" sx={{ mb: 3 }}>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {errors.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </Alert>
  );
}
